<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'RefreshComponent',
  data () {
    return {
      isFnPressed: false,
    }
  },
  beforeMount () {
    window.addEventListener('keydown', this.handleKeyboard);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyboard);
  },
  computed: {
    cuenta () {
      return this.$store.getters['Cuentas/selected']
    },
    cuentaSelected () {
      return this.cuenta && this.cuenta.id > 0;
    },
  },
  methods: {
    handleKeyboard(event) {
      if (event.key === 'F5' && !event.ctrlKey) {
        if (!this.isFnPressed) {
          this.isFnPressed = true;
          
          if (this.cuentaSelected) {
            this.onSubmit(event)
          } else {
            event.preventDefault();
            alert('Primero debe seleccionar una cuenta y un periodo!');
            this.isFnPressed = false;
          }
        }
      }
    },
    async onSubmit(event) {
      event.preventDefault()
      await this.$store.dispatch('Cuentas/onRefresh');
      await this.$store.dispatch('Transacciones/onFetch');
      this.isFnPressed = false;
    },
  },

}
</script>
